/** @format */

import React, { PureComponent } from 'react';
import Order from '../../interfaces/forms/Order';
import Filter from '../../interfaces/forms/Filter';
import { ListPropsInterface } from '../../modules/lib/ListPropsInterface';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FilterManager } from '../../modules/filter/FilterManager';
import { Auth, tokenInfo } from '../../modules/auth/Auth';
import { FilterReducerFieldName, FilterReducers } from '../../modules/filter/FilterReducers';
import { FilterListReducerFieldName } from '../../modules/filter/FilterListReducers';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import PaperedTable from '../../components/Table/PaperedTable';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import Pager from '../../components/Adescom/PagerRange';
import { TableFooter } from '@material-ui/core';
import FilterList from '../../components/Filter/FilterList';
import { PlatformIccidPoolNumberCollectionInterface } from '../../interfaces/collections/PlatformIccidPoolNumberCollectionInterface';
import { StorageIccidSuperUserItem } from './views/StorageIccidSuperUserItem';
import { IccidMvnoStatusHelper } from '../lib/search/IccidMvnoStatusHelper';
import { SimCardMnoTariffLoader } from '../../modules/tariffs/SimCardMnoTariffLoader';
import { history } from '../../core/history';
import { PlatformResellerLoader } from '../../modules/platformreseller/PlatformResellerLoader';
import { StorageIccidToCsv } from '../../modules/storage/StorageIccidToCsv';
import { StorageIccidPartnerUserItem } from './views/StorageIccidPartnerUserItem';
import { PlatformIccidMsisdnIpPoolReducerAction, PlatformIccidMsisdnIpPoolReducerType } from '../../modules/iccid/PlatformIccidMsisdnIpPoolReducer';
import { ImsiChangeRmoModelAdvance } from './imsi/ImsiChangeRmoModelAdvance';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import { ImsiChangeRmoTypeAdvance } from './imsi/ImsiChangeRmoTypeAdvance';
import { StoreStackReducerAction, StoreStackReducerType } from '../../modules/lib/StoreStackReducer';
import { PlatformRmoCollectionInterface } from '../../interfaces/collections/PlatformRmoInterface';
import { ImsiChangeOwner } from './imsi/ImsiChangeOwner';
import OplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import {NotificationHelper} from "../../helpers/NotificationHelper";

interface StorageImsiStateInterface {
    poolNumbers: PlatformIccidPoolNumberCollectionInterface | null;
    orders: Array<Order>;
    filters: Array<Filter>;
    showClearFilterButton: boolean;
    searchSendWithFitler: boolean;
    activeRow: number;
    pagginationUrl?: string | null;
    platformRmoCollection: PlatformRmoCollectionInterface | null;
}

interface StorageImsiPropsInterface extends ListPropsInterface {
    type?: string;
    platformRmoCollection?: PlatformRmoCollectionInterface | null;
}

class StorageImsi extends PureComponent<StorageImsiPropsInterface, StorageImsiStateInterface> {
    private loaderCall: ItemLoaders;
    private filterManage: FilterManager;
    private readonly iccidStatusHelper: IccidMvnoStatusHelper;
    private simCardMnoTariffLoader: SimCardMnoTariffLoader;

    constructor(props: ListPropsInterface, context: StorageImsiStateInterface) {
        super(props, context);
        this.state = {
            poolNumbers: null,
            orders: [],
            filters: [],
            activeRow: 0,
            searchSendWithFitler: false,
            showClearFilterButton: false,
            platformRmoCollection: null,
        };
        this.loaderCall = new ItemLoaders(this.props.dispatch);
        this.filterManage = new FilterManager();
        this.iccidStatusHelper = new IccidMvnoStatusHelper();
        this.simCardMnoTariffLoader = new SimCardMnoTariffLoader(this.loaderCall);
    }

    componentDidMount(): void {
        this.setDefaultFilter((): void => {
            this.firstLoad();
        });
        this.simCardMnoTariffLoader.load({
            callback: (): void => {},
            orders: [{ name: 'constName', value: 'asc' }],
            filters: [],
        });
    }

    componentDidUpdate(prevProps: Readonly<ListPropsInterface>, prevState: Readonly<StorageImsiStateInterface>, snapshot?: any): void {
        const { type, dispatch, headerFilterElementHasValue, headerFilterElementName, platformRmoCollection } = this.props;
        const { pagginationUrl } = this.state;
        if (headerFilterElementName) {
            if (headerFilterElementHasValue) {
                this.filterManage.manageElement(headerFilterElementName, headerFilterElementHasValue);
            } else {
                this.filterManage.manageElement(headerFilterElementName, false);
            }
            this.setState({ showClearFilterButton: this.filterManage.hasManageElement() });
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            });
        }
        if (
            type === PlatformIccidMsisdnIpPoolReducerAction.RMO_RELOAD_MAIN_LIST_AFTER_CHANGE_RMO ||
            type === PlatformIccidMsisdnIpPoolReducerAction.INDICATED_RANGE_RELOAD_MAIN_LIST_AFTER_CHANGE
        ) {
            dispatch({ type: PlatformIccidMsisdnIpPoolReducerAction.RMO_MODEL_NO_ACTION });
            if (pagginationUrl) {
                this.paginationCallbackFunction(pagginationUrl);
            } else {
                this.firstLoad();
            }
        }
        if (type === StoreStackReducerAction.LOAD_PLATFORM_RMO_MODEL_PARTNER_MVNE_LIST) {
            this.setState({ platformRmoCollection: platformRmoCollection ?? null });
        }
    }

    setActiveRow = (id: number): void => {
        const { activeRow } = this.state;
        if (activeRow === id) {
            id = 0;
        }
        this.setState({ activeRow: id });
    };

    clearFilter = (): void => {
        this.setDefaultFilter((): void => {
            const { dispatch } = this.props;
            const { searchSendWithFitler } = this.state;
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
                clearAll: true,
            });
            dispatch({
                type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
            });
            if (searchSendWithFitler) {
                this.firstLoad();
            }
        });
    };

    updateOrderList = (orders: Array<Order>): void => this.setState({ orders: orders }, this.firstLoad);
    updateFilterList = (filters: Array<Filter>): void => this.setState({ filters: filters });

    setDefaultFilter = (callback: () => void): void => {
        this.setState(
            {
                showClearFilterButton: false,
                orders: [{ name: 'imsi', value: 'asc' }],
                filters: [],
            },
            (): void => {
                callback();
            }
        );
    };

    firstLoad = (): void => {
        const { filters, orders, showClearFilterButton } = this.state;
        const { dispatch, showMainLoader } = this.props;
        showMainLoader(true);
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_iccid_pool_numbers')),
            'storage_imsi_loader_items',
            filters,
            orders,
            (items: PlatformIccidPoolNumberCollectionInterface): void => {
                this.setState({ poolNumbers: items, searchSendWithFitler: showClearFilterButton, pagginationUrl: null });
                showMainLoader(false);
                dispatch({
                    type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
                    showRender: true,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    paginationCallbackFunction = (uri: string): void => {
        const { showMainLoader } = this.props;
        showMainLoader(true);
        this.loaderCall.paginationCallWithCallback(
            uri,
            'storage_imsi_loader_items',
            (items: PlatformIccidPoolNumberCollectionInterface): void => {
                this.setState({ poolNumbers: items, pagginationUrl: uri });
                showMainLoader(false);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    exportToCsv = (): void => {
        const { filters, orders, platformRmoCollection ,poolNumbers} = this.state;
        const { showMainLoader,dispatch } = this.props;
        if(poolNumbers && !poolNumbers['hydra:totalItems']) {
            NotificationHelper.notifyError('general:common.no_data_to_export', dispatch);
            return;
        }
        if (platformRmoCollection) {
            const toCsv = new StorageIccidToCsv(
                this.loaderCall,
                new PlatformResellerLoader(this.loaderCall),
                this.iccidStatusHelper,
                this.simCardMnoTariffLoader,
                platformRmoCollection
            );
            toCsv.exportToCsv(
                (UserRoleHelper.checkRole(roles.ROLE_PLATFORM_ICCID_POOL_NUMBER_GET) &&
                    !UserRoleHelper.checkRole(roles.ROLE_ICCID_PLATFORM_POOL_NUMBER_PARTNER_VIEW)) ||
                    UserRoleHelper.checkRole(roles.ROLE_SUPERUSER),
                orders,
                filters,
                showMainLoader
            );
        }
    };

    viewCallback = (iri: { uri: string }, event: any): void => this.pushCallback('/iccid-view' + iri.uri, event);

    changeModelRmo = (): void => {
        const { dispatch } = this.props;
        dispatch({
            type: PlatformIccidMsisdnIpPoolReducerAction.RMO_CHANGE_OPEN_DIALOG_ADVANCED,
            openChangeRmoAdv: true,
        } as PlatformIccidMsisdnIpPoolReducerType);
    };

    changeIndicatedRange = (): void => {
        const { dispatch } = this.props;
        dispatch({
            type: PlatformIccidMsisdnIpPoolReducerAction.INDICATED_RANGE_CHANGE_OPEN_DIALOG_ADVANCED,
            openChangeIndicateRangeAdv: true,
        } as PlatformIccidMsisdnIpPoolReducerType);
    };

    changeOwner = (): void => {
        const { dispatch } = this.props;
        dispatch({
            type: PlatformIccidMsisdnIpPoolReducerAction.IMSI_CHANGE_OWNER_OPEN_DIALOG_ADVANCED,
            openImsiChangeOwner: true,
        } as PlatformIccidMsisdnIpPoolReducerType);
    };

    pushCallback = (uri: string, event: any): void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.respectModifierPush(event, FormGeneralHelper.getRouteUrl(uri));
    };

    viewPoolManager = (iri: { uri: string }, event: any): void => this.pushCallback('/imsi-pool-manage', event);

    render(): React.ReactNode {
        const { classes } = this.props;
        const { showClearFilterButton, poolNumbers, filters, orders, activeRow } = this.state;
        const tableControlStickyHeader = { root: classes.tableControlStickyHeader };

        return (
            <GridContainer>
                <GridItem xs={12} md={12} lg={12}>
                    <PaperedTable
                        beforeTableContent={
                            <GridContainer>
                                <GridItem xs={12} className={classes.beforeTableContent}>
                                    <CustomTextButtom
                                        callback={this.firstLoad}
                                        callbackParam={{}}
                                        color="primary"
                                        label="general:common.search"
                                        size="lg"
                                    />
                                    {showClearFilterButton && (
                                        <CustomTextButtom
                                            callback={this.clearFilter}
                                            callbackParam={{}}
                                            color="primary"
                                            label="general:common.clear"
                                            size="lg"
                                        />
                                    )}
                                    <CustomTextButtom
                                        callback={this.exportToCsv}
                                        callbackParam={{}}
                                        color="primary"
                                        label="general:common.export_to_csv"
                                        size="lg"
                                    />
                                    {UserRoleHelper.checkRole(roles.ROLE_UPLOAD_ICCID_POOLS) && (
                                        <CustomTextButtom
                                            callback={this.viewPoolManager}
                                            callbackParam={{ uri: 'no-uri' }}
                                            color="primary"
                                            label="pools:msisdn.pool_manage"
                                            size="lg"
                                        />
                                    )}
                                    {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_IMSI_POOLS_CHANGE_OWNER_PUT) && (
                                        <React.Fragment>
                                            <CustomTextButtom
                                                callback={this.changeOwner}
                                                callbackParam={{}}
                                                color="primary"
                                                label="pools:sim.owner_change"
                                                size="lg"
                                            />
                                        </React.Fragment>
                                    )}

                                    <FilterList />
                                </GridItem>
                            </GridContainer>
                        }
                    >
                        {((UserRoleHelper.checkRole(roles.ROLE_PLATFORM_ICCID_POOL_NUMBER_GET) &&
                            !UserRoleHelper.checkRole(roles.ROLE_ICCID_PLATFORM_POOL_NUMBER_PARTNER_VIEW)) ||
                            UserRoleHelper.checkRole(roles.ROLE_SUPERUSER)) &&
                            poolNumbers && (
                                <StorageIccidSuperUserItem
                                    poolItems={poolNumbers['hydra:member']}
                                    viewCallback={this.viewCallback}
                                    classes={classes}
                                    setActiveRow={this.setActiveRow}
                                    activeRow={activeRow}
                                    firstLoad={this.firstLoad}
                                    updateOrderList={this.updateOrderList}
                                    updateFilterList={this.updateFilterList}
                                    filters={filters}
                                    orders={orders}
                                    iccidStatusHelper={this.iccidStatusHelper}
                                    simCardMnoTariffLoader={this.simCardMnoTariffLoader}
                                />
                            )}
                        {UserRoleHelper.checkRole(roles.ROLE_ICCID_PLATFORM_POOL_NUMBER_PARTNER_VIEW) &&
                            !UserRoleHelper.checkRole(roles.ROLE_SUPERUSER) &&
                            poolNumbers && (
                                <StorageIccidPartnerUserItem
                                    poolItems={poolNumbers['hydra:member']}
                                    viewCallback={this.viewCallback}
                                    classes={classes}
                                    setActiveRow={this.setActiveRow}
                                    activeRow={activeRow}
                                    firstLoad={this.firstLoad}
                                    updateOrderList={this.updateOrderList}
                                    updateFilterList={this.updateFilterList}
                                    filters={filters}
                                    orders={orders}
                                    iccidStatusHelper={this.iccidStatusHelper}
                                    simCardMnoTariffLoader={this.simCardMnoTariffLoader}
                                />
                            )}
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={10}>
                                    {poolNumbers && poolNumbers['hydra:view'] && (
                                        <Pager callback={this.paginationCallbackFunction} views={poolNumbers} />
                                    )}
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </PaperedTable>
                    <ImsiChangeRmoModelAdvance />
                    <ImsiChangeRmoTypeAdvance />
                    <ImsiChangeOwner />
                </GridItem>
            </GridContainer>
        );
    }
}

const stateToProps = (state: {
    filterReducer: FilterReducers;
    platformIccidMsisdnIpPoolReducer: PlatformIccidMsisdnIpPoolReducerType;
    storeStackReducer: StoreStackReducerType;
}): object => {
    const { filterReducer, platformIccidMsisdnIpPoolReducer, storeStackReducer } = state;
    if (filterReducer && filterReducer.headerFilterElementName) {
        return {
            headerFilterElementHasValue: filterReducer.headerFilterElementHasValue,
            headerFilterElementName: filterReducer.headerFilterElementName,
        };
    }
    if (platformIccidMsisdnIpPoolReducer.type) {
        return {
            type: platformIccidMsisdnIpPoolReducer.type,
        };
    }
    if (storeStackReducer.type) {
        if (storeStackReducer.type === StoreStackReducerAction.LOAD_PLATFORM_RMO_MODEL_PARTNER_MVNE_LIST) {
            return {
                type: storeStackReducer.type,
                platformRmoCollection: storeStackReducer.platformRmoCollection,
            };
        }
    }
    return {};
};

export default compose<any, any>(connect(stateToProps), withStyles(OplAppStyle))(StorageImsi);
